import type {
  StripeCheckoutAddressElementOptions,
  StripeCheckoutPaymentElementOptions,
} from '@stripe/stripe-js'

export const DEFAULT_CHECKOUT_BILLING_COUNTRY = 'US'

// Email is collected above the Payment Element; name and address live on
// BillingAddressElement. Phone and Link stay off so Stripe does not render a
// number field whose country selector can show +1 without binding a country.
export const CHECKOUT_PAYMENT_ELEMENT_OPTIONS = {
  layout: 'accordion',
  fields: {
    billingDetails: {
      name: 'never',
      email: 'never',
      phone: 'never',
      address: 'never',
    },
  },
  wallets: { link: 'never' },
} satisfies StripeCheckoutPaymentElementOptions

// Checkout's BillingAddressElement only accepts `display` and `contacts`.
// Extra Address Element keys (defaultValues, fields, validation) throw
// IntegrationError at createBillingAddressElement(). Do not also call
// updateBillingAddress() while this element is mounted — confirm() then throws.
export const CHECKOUT_BILLING_ADDRESS_OPTIONS = {
  display: { name: 'organization' },
} satisfies StripeCheckoutAddressElementOptions

type BillingAddressCountrySource = {
  address?: { country?: string | null } | null
}

export function billingAddressNeedsDefaultCountry(
  billingAddress: BillingAddressCountrySource | null | undefined
): boolean {
  return !billingAddress?.address?.country?.trim()
}
